class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
    document.dispatchEvent(new Event("initCartFunctions"));
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ]; 
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

let clearBtn = document.querySelector("#remove-discount-code");
let applyBtn = document.querySelector("#apply-discount-button");
let discountCodeError = document.querySelector("#discount-code-error");
let discountCodeWrapper = document.querySelector(
  "#applied-discount-code .applied-discount-code-wrapper"
);
let discountCodeValue = document.querySelector(
  "#applied-discount-code .applied-discount-code-value"
);
let discountCodeInput = document.querySelector("#discount-coupon-text");
let totalCartSelector = document.querySelector(".cart__subtotal .money"); // no longer used for discount localStorage
let authorization_token;

let checkoutContainer = document.createElement("div");

initCartFunctions();

document.addEventListener("initCartFunctions", () => {
  initCartFunctions();
});

function initCartFunctions() {
  console.log("ddddddd");
  let clearBtn = document.querySelector("#remove-discount-code");
  let applyBtn = document.querySelector("#apply-discount-button");
  let discountCodeError = document.querySelector("#discount-code-error");
  let discountCodeWrapper = document.querySelector(
    "#applied-discount-code .applied-discount-code-wrapper"
  );
  let discountCodeValue = document.querySelector(
    "#applied-discount-code .applied-discount-code-value"
  );
  let discountCodeInput = document.querySelector("#discount-coupon-text");
  let totalCartSelector = document.querySelector(".cart__subtotal .money"); // no longer used for discount localStorage
  let authorization_token;

  let checkoutContainer = document.createElement("div");
  $(".subscription-info svg")
    .unbind()
    .click(function () {
      $(this).next(".subscription-info-content").toggle();
    });

  $("cart-drawer-items .item-frequency").each(function () {
    $(this)
      .find("option")
      .each(function () {
        var str = $(this).attr("data-frequency");
        $(this).attr("data-frequency", str.replace(/[^0-9.]/g, ""));
      });
  });

  $(".drawer-subscription-wrapper .item-frequency")
    .unbind()
    .change(function () {
      var cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      var key = $(this)
        .parents(".drawer-subscription-wrapper")
        .find(".togglesubscription")
        .attr("id");

      var selling_plan = $(this)
        .parents(".drawer-subscription-wrapper")
        .find(".item-frequency")
        .val();
      var qty = $(this)
        .parents(".cart-item__quantity")
        .find(".quantity__input")
        .val();

      $.ajax({
        method: "POST",
        url: "/cart/change.js",
        data: {
          id: key,
          quantity: qty,
          selling_plan: selling_plan,
          sections: cart.getSectionsToRender().map((section) => section.id),
        },
        dataType: "json",
        success: function (data) {
          reloadDrawer();
        },
      });
    });

  $(".subscription-wrapper input")
    .unbind()
    .change(function () {
      var cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      if ($(this).is(":checked")) {
        $(this)
          .parents(".drawer-subscription-wrapper")
          .find(".drawer-dropdown")
          .show();
        var key = $(this).attr("id");
        var selling_plan = $(this)
          .parents(".drawer-subscription-wrapper")
          .find(".item-frequency")
          .val();
        var qty = $(this)
          .parents(".cart-item__quantity")
          .find(".quantity__input")
          .val();

        if (
          $(this)
            .parents(".drawer-subscription-wrapper")
            .find(".item-frequency")
            .find('option[data-frequency="4"]').length > 0
        ) {
          $(this)
            .parents(".drawer-subscription-wrapper")
            .find(".item-frequency")
            .val(
              $(this)
                .parents(".drawer-subscription-wrapper")
                .find(".item-frequency")
                .find('option[data-frequency="4"]')
                .attr("value")
            );
          selling_plan = $(this)
            .parents(".drawer-subscription-wrapper")
            .find(".item-frequency")
            .find('option[data-frequency="4"]')
            .attr("value");
        }
        $.ajax({
          method: "POST",
          url: "/cart/change.js",
          data: {
            id: key,
            quantity: qty,
            selling_plan: selling_plan,
            sections: cart.getSectionsToRender().map((section) => section.id),
          },
          dataType: "json",
          success: function (data) {
            reloadDrawer();
          },
        });
      }

      if (!$(this).is(":checked")) {
        $(this)
          .parents(".drawer-subscription-wrapper")
          .find(".drawer-dropdown")
          .hide();
        var key = $(this).attr("id");
        var selling_plan = $(this)
          .parents(".drawer-subscription-wrapper")
          .find(".item-frequency")
          .val();
        var qty = $(this)
          .parents(".cart-item__quantity")
          .find(".quantity__input")
          .val();
        $.ajax({
          method: "POST",
          url: "/cart/change.js",
          data: {
            id: key,
            quantity: qty,
            selling_plan: "",
            sections: cart.getSectionsToRender().map((section) => section.id),
          },
          dataType: "json",
          success: function (data) {
            reloadDrawer();
          },
        });
      }
    });

  var swiper = new Swiper(".complementory-products-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
    },
    navigation: {
      nextEl: ".complementory-next",
      prevEl: ".complementory-prev",
    },
  });

  $(".discount-heading")
    .unbind()
    .click(function () {
      var $this = $(this);
      $this.next().toggleClass("active");

      setTimeout(function () {
        $this.next().removeClass("active");
      }, 20000);
    });
  $(".complementory-products-atc")
    .unbind()
    .click(function () {
      var varid = $(this).data("varid");
      $(this).find(".loading__spinner").removeClass("hidden");
      $(this).find(".atc-text").css("opacity", "0");
      var this2 = this;
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: varid, quantity: 1 }),
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          $(this2).find(".loading__spinner").addClass("hidden");
          $(this2).find(".atc-text").css("opacity", "1");
          reloadDrawer();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });

  $(".bundle-close-button").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var updates = {};
    var bundleadded = false;
    $(this).find(".close-btn-icon").hide();
    $(this).find(".loading__spinner ").removeClass("hidden");
    $(".bundle-cart-item .bundle-items").each(function () {
      updates[$(this).data("itemkey")] = 0;
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: updates,
      }),
    })
      .then((response) => response.json())
      .then((newCart) => {
        var ID = $(".main-progress-bar-container").data("freeitem");
        var threshhold = $(".secondstagecprice").data("price");
        console.log(newCart.items_subtotal_price);
        console.log(threshhold);
        for (var i = 0; i < newCart.items.length; i++) {
          var properties = newCart.items[i].properties;
          if (newCart.items[i].variant_id == ID) {
            bundleadded = true;
            updates[newCart.items[i].key] = 0;
          }
        }

        if (bundleadded == true) {
          fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              updates: updates,
            }),
          })
            .then((response) => response.json())
            .then((newCart) => {
              reloadDrawer();
            })
            .catch(console.error);
        } else {
          reloadDrawer();
        }
      })
      .catch(console.error);
  });

  document.body.appendChild(checkoutContainer);

  if (applyBtn)
    applyBtn.addEventListener("click", function (e) {
      e.preventDefault();
      applyDiscount(discountCodeInput.value);
    });
  if (clearBtn)
    clearBtn.addEventListener("click", function (e) {
      console.log("buttn clicked clear");
      e.preventDefault();
      clearDiscount();
    });

  // NEW clearDiscount using cart/update.js (no localStorage)
  function clearDiscount() {
    if (clearBtn) {
      clearBtn.innerHTML = "Removing..";
    }

    $(".discount-announcement-slider.discounted-wrapper").hide();
    $(".discount-announcement-slider.non-discounted-wrapper").show();

    const formData = new FormData();
    formData.append("discount", ""); // empty string = remove all discounts

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        reloadDrawer();
        // var applycode = new CustomEvent("applyDiscountCode", {
        //     detail: { code: code },
        //   });
        //   document.dispatchEvent(applycode);
        $("main-product-form").load(location.href + " main-product-form");
      })
      .catch((error) => {
        console.error("Clear discount error:", error);
      })
      .finally(() => {
        if (clearBtn) {
          clearBtn.innerHTML = "Clear";
        }
      });
  }

  // NEW applyDiscount using cart/update.js (no payments/wallets, no localStorage)
  function applyDiscount(code) {
    code = (code || "").trim();
    if (!code) return;

    $(".discount-announcement-slider.discounted-wrapper").show();
    $(".discount-announcement-slider.non-discounted-wrapper").hide();

    if (applyBtn) {
      applyBtn.innerHTML = "Applying.. <div class='loader'></div>";
      applyBtn.style.pointerEvents = "none";
    }

    const formData = new FormData();
    formData.append("discount", code);

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) =>
        response.json().then((cart) => ({ cart, ok: response.ok }))
      )
      .then(({ cart, ok }) => {
        const hasDiscount =
          (cart.cart_level_discount_applications &&
            cart.cart_level_discount_applications.length > 0) ||
          (typeof cart.total_discount === "number" &&
            cart.total_discount > 0);

        if (!ok || !hasDiscount) {
          throw new Error("INVALID_DISCOUNT");
        }

        if (discountCodeWrapper) {
          discountCodeWrapper.style.display = "inline";
        }
        if (discountCodeError) {
          discountCodeError.innerHTML = "";
        }

        if (discountCodeValue) {
          let title = code;
          if (
            cart.cart_level_discount_applications &&
            cart.cart_level_discount_applications.length > 0
          ) {
            title =
              cart.cart_level_discount_applications[0].title || code;
          }

          let amountText = "";
          if (
            typeof cart.total_discount === "number" &&
            cart.total_discount > 0
          ) {
            const amount = (cart.total_discount / 100).toFixed(2);
            amountText =
              " (" + Shopify.currency.active + " " + amount + ")";
          }

          discountCodeValue.innerHTML = title + amountText;
        }

        setTimeout(function () {
          reloadDrawer();

          var applycode = new CustomEvent("applyDiscountCode", {
            detail: { code: code },
          });
          document.dispatchEvent(applycode);
           //$("main-product-form").load(location.href + " main-product-form");
        }, 500);

        $(".discount-boxes-wrapper").removeClass("dsicount-eeor");
        $("#discount-code-error").hide();
      })
      .catch((error) => {
        if (discountCodeValue) {
          discountCodeValue.innerHTML = "";
        }

        if (discountCodeError) {
          discountCodeError.innerHTML = "Please Enter Valid Coupon Code.";
        }

        $(".discount-boxes-wrapper").addClass("dsicount-eeor");
        $("#discount-code-error").show();
        $(".discount-announcement-slider.discounted-wrapper").hide();
        $(".discount-announcement-slider.non-discounted-wrapper").show();
      })
      .finally(() => {
        if (applyBtn) {
          applyBtn.innerHTML = "Apply";
          applyBtn.style.pointerEvents = "auto";
        }
      });
  }

  $(".cart__checkout-button")
    .unbind()
    .click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).find(".loading__spinner").removeClass("hidden");
      $(this).find("span").hide();
      var this2 = this;
      var bundleadded = false;
      var updates = {};
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (cartdata) {
          var ID = $(".main-progress-bar-container").data("freeitem");
          var threshhold = $(".secondstagecprice").data("price");
          console.log(cartdata.items_subtotal_price);
          console.log(threshhold);
          for (var i = 0; i < cartdata.items.length; i++) {
            var properties = cartdata.items[i].properties;
            if (cartdata.items[i].variant_id == ID) {
              bundleadded = true;
              updates[cartdata.items[i].key] = 0;
            }
          }

          if (bundleadded == true) {
            fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                updates: updates,
              }),
            })
              .then((response) => response.json())
              .then((newCart) => {
                addFreeProduct();
              })
              .catch(console.error);
          } else {
            addFreeProduct();
          }
          function addFreeProduct() {
            if (cartdata.items_subtotal_price >= threshhold) {
              $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                  quantity: 1,
                  id: ID,
                  properties: { _freeGift: true },
                },
                dataType: "json",
                success: function (data) {
                  $(this2).find(".loading__spinner").addClass("hidden");
                  $(this2).find("span").show();
                  window.location.href = "/checkout";
                },
              });
            } else {
              $(this2).find(".loading__spinner").addClass("hidden");
              $(this2).find("span").show();
              window.location.href = "/checkout";
            }
          }
        },
      });
    });
}

class BundleItems extends HTMLElement {
  constructor() {
    super();
  }
}
customElements.define("bundle-items", BundleItems);

let searchParams = new URLSearchParams(window.location.search);

if (searchParams.has("discount")) {
  if (searchParams.has("cart_items")) {
    var cart_items = searchParams.get("cart_items");
    var aritems = cart_items.split("___");
    var additems = [];
    for (let i = 0; i < aritems.length; i++) {
      var aritem = aritems[i].split("_");
      var job = {};
      job["id"] = aritem[0];
      job["quantity"] = aritem[1];
      if (aritem[2]) {
        job["selling_plan"] = aritem[2];
      }
      job["properties"] = {
        _disabled_item: true,
      };
      additems.push(job);
    }
    var cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    $.ajax({
      type: "GET",
      url: "/cart/clear.js",
      dataType: "json",
      success: function (cartdata) {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData();
        if (cart) {
          formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }

        for (let index = 0; index < additems.length; index++) {
          formData.append("items[" + index + "][id]", additems[index]["id"]);
          formData.append(
            "items[" + index + "][quantity]",
            additems[index]["quantity"]
          );
          formData.append(
            "items[" + index + "][properties][_disabled_item]",
            true
          );
          if (additems[index]["selling_plan"]) {
            formData.append(
              "items[" + index + "][selling_plan]",
              additems[index]["selling_plan"]
            );
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            cart.renderContents(response);
            cart.open();
            $("cart-drawer").removeClass("is-empty");
            document.dispatchEvent(new Event("initCartFunctions"));
            applyUrlDiscount();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {});
      },
    });
  } else {
    applyUrlDiscount();
  }
}

// NEW applyUrlDiscount using cart/update.js (no localStorage)
function applyUrlDiscount() {
  var code = searchParams.get("discount");
  if (!code) return;

  if (discountCodeInput) {
    discountCodeInput.value = code;
  }

  const formData = new FormData();
  formData.append("discount", code);

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    body: formData,
    headers: {
      Accept: "application/json",
    },
  })
    .then((response) => response.json())
    .then((cart) => {
      $(".first-order").show();
      setTimeout(function () {
        reloadDrawer();
        var applycode = new CustomEvent("applyDiscountCode", {
          detail: { code: code },
        });
        document.dispatchEvent(applycode);
      }, 1000);
    })
    .catch((error) => {
      console.error("Discount from URL error:", error);
    });
}

$(".discount-text")
  .unbind()
  .click(function () {
    $(this).parent(".discount-boxes-wrapper").removeClass("dsicount-eeor");
    $("#discount-code-error").hide();
  });

function reloadDrawer() {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const selectors = [
        "cart-drawer-items",
        ".cart-drawer__footer",
        ".drawer-discount-wrapper",
      ];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
      document.dispatchEvent(new Event("initCartFunctions"));
    })
    .catch((e) => {
      console.error(e);
      document.dispatchEvent(new Event("initCartFunctions"));
    });
    reloadDiscountAnnouncement()
}
function reloadDiscountAnnouncement() {
  const sectionId = document.querySelector('discount-announcement').dataset.sectionid;

  fetch(`/?section_id=${sectionId}`)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newSection = doc.querySelector('discount-announcement');
      const oldSection = document.querySelector('discount-announcement');

      if (newSection && oldSection) {
        oldSection.replaceWith(newSection);
      }
      window.dispatchEvent(new Event('resize'));
    });
}